import React, { useReducer } from "react"
import { graphql, Link } from "gatsby"
import Parser from 'html-react-parser';

import { Location } from '@reach/router'
import Layout from 'components/layout'
import SEO from 'components/common/seo';
import ShareButtons from 'components/common/share';
import Util from 'components/common/util';
import Disqus from 'disqus-react';

import SliceZone from 'components/blog/slicezone'
import BlogMap from "components/blog/blogmap"

const BlogTemplate = ({data:{prismicBlog},pageContext}) => {
  const { data } = prismicBlog
  const disqusShortname = 'gadaabout';
  const disqusConfig = {
      url: "https://gion.si/gadaabout/blog/"+pageContext.uid,
      identifier: pageContext.uid,
      title: data.title.text,
  };

  let blogmapdata = null
  if(data.geoevent.latitude != null && data.geoevent.longitude != null &&
    data.geoevent.latitude != 0 && data.geoevent.longitude != 0) {
      blogmapdata = {
        "markertext": data.geoevent_marketpointlabel != null ? data.geoevent_marketpointlabel : '',
        "position" : [data.geoevent.latitude, data.geoevent.longitude],
        "permanent" : true
      }
    }
  return (
    <Layout>
      <Location>
        {({ location }) => {
          return (
            <SEO
              title={data.title.text}
              description={data.subtitle.text}
              pathname={location.pathname}
              image={data.image.localFile.childImageSharp.fluid.src}
              article
            />
          )
        }}
      </Location>      
      <section className="wrapper style1 align-center">
      <div className="inner">
      <div className="align-left">
        <section style={{paddingTop:'0px'}}>
          <div className="content">
          <header>
            <h1>{data.title.text} {pageContext.path}</h1>
            {Parser(data.subtitle.html)}
            <span className="datePost">Scritto il {data.publishdate} in </span>
            <span className="tagPostList">
                {data.tags.map(({tag:tagItem}, k) => (
                    <Link key={k} to={`/tag/${tagItem.slug}`}>#{Util.renderTagLabel(tagItem)}</Link>
                ))}
            </span>
          </header>
          {blogmapdata != null ? (
            <BlogMap options={blogmapdata}></BlogMap>
          ) : ''}
          <hr/>
          </div>
        </section>
      </div>
      <div className="align-left">
        <section style={{paddingTop:'0px'}}>
          <div className="content">
            <SliceZone allSlices={data.body} />
            <ShareButtons/>
            <hr/>
            <Disqus.DiscussionEmbed shortname={disqusShortname} config={disqusConfig} />
          </div>
        </section>
      </div>
      </div>
      </section>
    </Layout>
  )
}
export default BlogTemplate

export const pageQuery = graphql`
query PostBySlug($uid: String!) {
  prismicBlog(uid: {eq: $uid}) {
    uid
    data {
      title {
        text
      }
      subtitle {
        html
        text
      }
      geoevent_marketpointlabel
      geoevent {
        latitude
        longitude
      }
      publishdate(formatString: "DD/MM/YYYY")
      tags {
        tag {
          slug
          document {
            data {
              label
            }
          }
        }
      }
      image {
        localFile {
          childImageSharp {
            fluid(maxWidth: 400, quality: 90) {
              ...GatsbyImageSharpFluid_withWebp
              src
            }
          }
        }
      }
      body {
        ... on PrismicBlogBodyText {
          slice_type
          primary {
            text {
              html
            }
          }
        }
        ... on PrismicBlogBodyQuote {
          slice_type
          id
          primary {
            quote {
              html
            }
            name_of_the_author {
              text
            }
            portrait_author {
              localFile {
                childImageSharp {
                  fluid(maxWidth: 150, quality: 90) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
          }
        }
        ... on PrismicBlogBodyImageSingle {
          slice_type
          primary {
            imgcaption {
              html
            }
            img {
            	dimensions {
                width
                height
              }  
              alt
              copyright
            	url
              localFile {
                childImageSharp {
                  fluid(maxWidth: 750, quality: 90) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
          }
        }
        ... on PrismicBlogBodyEmbedded {
          slice_type
          primary {
            embed_title {
              html
              text
            }
            external_content {
              version
              type
              thumbnail_url
              thumbnail_width
              thumbnail_height
              provider_name
              provider_url
              author_url
              author_name
              title              
              embed_url
              url
              html
            }
          }
        }
        ... on PrismicBlogBodyListOfArticles {
          slice_type
          id
          primary {
            title_of_section {
              html
            }
          }
          items {
            articles_to_link {
              id
              type
              slug
              lang
              link_type
              isBroken
              url
              target
              document {
                data {
                  title {
                    text
                  }
                  publishdate(formatString: "DD/MM/YYYY")
                  subtitle {
                    html
                  }
                  image {
                    localFile {
                      childImageSharp {
                        fluid(maxWidth: 150, quality: 90) {
                          ...GatsbyImageSharpFluid_withWebp
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        ... on PrismicBlogBodyImageGallery {
          slice_type
          id
          primary {
            name_of_the_gallery {
              html
            }
          }
          items {
            gallery_image {
              alt
              dimensions {
                width
                height
              }
              copyright
              localFile {
                childImageSharp {
                  fluid(maxWidth: 250, quality: 90) {
                    ...GatsbyImageSharpFluid_withWebp
                    src
                  }
                }
            	}
            }
            image_captions {
              text
            }
          }
        }
      }
    }
  }
}
`

// not used
// embed_image {
//   dimensions {
//     width
//     height
//   }
//   alt
//   copyright
//   url
//   localFile {
//     childImageSharp {
//       fluid(maxWidth: 750, quality: 90) {
//         ...GatsbyImageSharpFluid_withWebp
//       }
//     } 
//   }
// }